import { useSearchParams, useNavigate } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { toast } from "sonner";
import { QrCode } from "lucide-react";
import { useI18n } from "../lib/LanguageContext";

export default function PaymentSimulate() {
  const { t } = useI18n();
  const [sp] = useSearchParams(); const sessionId = sp.get("session_id");
  const nav = useNavigate(); const { refresh } = useAuth();

  const confirm = async () => {
    try {
      await api.post(`/payments/simulate-confirm/${sessionId}`);
      await refresh(); toast.success(t("payment.payment_success"));
      nav(`/payment/success?session_id=${sessionId}`);
    } catch (err) { toast.error(err.response?.data?.detail || t("payment.confirm_failed")); }
  };
  return (
    <div className="max-w-md mx-auto py-16 px-6" data-testid="payment-simulate">
      <Card className="rounded-2xl p-8 text-center">
        <div className="w-24 h-24 mx-auto rounded-md bg-teal-soft flex items-center justify-center mb-4"><QrCode className="w-16 h-16 text-teal"/></div>
        <h1 className="font-display text-2xl font-medium mb-2">{t("payment.scan")}</h1>
        <p className="text-sm text-muted-foreground mb-2">Session: <span className="font-mono text-xs">{sessionId}</span></p>
        <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-md text-left">
          <div className="text-xs font-bold uppercase tracking-widest text-amber-800 mb-1">⚠ {t("payment.simulation")}</div>
          <p className="text-xs text-amber-800">{t("payment.simulation_desc")}</p>
        </div>
        <Button onClick={confirm} className="w-full mt-6 rounded-full bg-teal hover:bg-teal/90 text-white" data-testid="simulate-confirm-btn">{t("payment.confirm_simulation")}</Button>
        <Button variant="outline" onClick={()=>nav("/harga")} className="w-full mt-3 rounded-full">{t("payment.cancel")}</Button>
      </Card>
    </div>
  );
}
